import { useEffect } from "react";
import { useSelector } from "react-redux";
import { useQueryClient } from "@tanstack/react-query";
import { borrowerService } from "@/services/borrowers";
import { queryKeys } from "@/queryKeys";
import { RootState } from "@/store/store";
import type { Borrower } from "@/types/borrower";

/**
 * When an underwriter opens an unclaimed borrower, claim it for them and
 * invalidate the borrowers list so the new ownership is reflected.
 */
export function useClaimBorrowerOnOpen(
  borrowerId: number | null,
  borrower: Borrower | null | undefined
): void {
  const user = useSelector((state: RootState) => state.auth.user);
  const queryClient = useQueryClient();

  useEffect(() => {
    if (user?.role === "underwriter" && borrowerId && borrower && !borrower.underwriter_email) {
      void borrowerService
        .claim(borrowerId)
        .then(() => queryClient.invalidateQueries({ queryKey: queryKeys.borrowers() }));
    }
  }, [borrowerId, borrower, queryClient, user?.role]);
}
